import { store } from "./store";
import { CLEAR } from "@/utils/constants";

export function clearStore() {
    store.dispatch({ type: CLEAR });
}
